export const firebaseConfig = {
  apiKey: "AIzaSyCRHT5rNIhUvsG4UExnQorf-IKkmVoOFhk",
  authDomain: "tawkit-1.firebaseapp.com",
  projectId: "tawkit-1",
  storageBucket: "tawkit-1.appspot.com",
  messagingSenderId: "945034062872",
  appId: "1:945034062872:web:dde0d8676943638c1b676d",
  measurementId: "G-6MWB4LVZH8",
};

export default firebaseConfig;
